module.exports = __webpack_public_path__ + "img/GEORGIA-FS-CW.c49269db.png";